<template>
  <div ref="Boyofilter"
       class="Boyo-filter">
    <el-form :inline="true"
             ref="filter"
             :model="searchInfo"
             class="demo-form-inline">
      <el-form-item v-for="item of filter.list"
                    ref="filterstwo"
                    v-show="item.shows?item.show:true"
                    :key="item.label"
                    :label="item.label">
        <el-input v-if="item.type == 'text'"
                  v-model="searchInfo[item.value]"
                  :clearable="item.clearable?false:true"
                  size="small"
                  :style="item.style ? item.style : 'width:140px'"
                  :disabled="item.disabled">
        </el-input>
        <el-select v-else-if="item.type == 'select'"
                   v-model="searchInfo[item.value]"
                   :clearable="item.clearable?false:true"
                   :disabled="item.disabled?true:false"
                   :remote="item.remote"
                   :remote-method="item.remote ? remoteMethod : none"
                   @focus="item.remote ? focus(item.value) : ''"
                   @change="selectChange"
                   :loading="item.loading"
                   filterable
                   size="small"
                   :style="item.style ? item.style : 'width:150px'">
          <template slot="prefix" v-if="item.prefix">
            <i class="el-icon-search select_header" :size="item.size?item.size:'small'" @click.stop="selectHeaderClick(item.label)"></i>
          </template>
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type == 'selectMultiple'"
                   v-model="searchInfo[item.value]"
                   :clearable="item.clearable?false:true"
                   :remote="item.remote"
                   :remote-method="item.remote ? remoteMethod : none"
                   @focus="item.remote ? focus(item.value) : ''"
                   @change="selectChange"
                   :loading="item.loading"
                   filterable
                   multiple
                   size="small"
                   :style="item.style ? item.style : 'width:150px'">
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type == 'selectCreate'"
                   v-model="searchInfo[item.value]"
                   :clearable="item.clearable?false:true"
                   :remote="item.remote"
                   :remote-method="item.remote ? remoteMethod : none"
                   @focus="item.remote ? focus(item.value) : ''"
                   @change="selectChange"
                   :loading="item.loading"
                   filterable
                   allow-create
                   default-first-option
                   size="small"
                   :style="item.style ? item.style : 'width:150px'">
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-select v-else-if="item.type == 'selectPartner'"
                  v-model="searchInfo[item.value]"
                  :clearable="item.clearable?false:true"
                  :remote="item.remote"
                  :remote-method="item.remote ? remoteMethod : none"
                  @focus="item.remote ? focus(item.value) : ''"
                  @change="selectChange"
                  :loading="item.loading"
                  filterable
                  size="small"
                   :style="item.style ? item.style : 'width:150px'">
          <div style="padding-left: 20px;width: 760px;height: 20px;line-height: 20px;background: #fff;position: absolute;top: -1px;z-index: 1;">
            <span style="float: left;width:80px">编号</span>
            <span style="float: left;width:390px">单位名称</span>
            <span style="float: left;width:80px">性质</span>
            <span style="float: left;width:110px">区域</span>
            <span style="float: left;width:100px">联系电话</span>
          </div>
          <el-option v-for="(item,index) in listTypeInfo[item.list]"
                    :key="item.value" :class="index == 0?'selectPartner':'selectPartner2'"
                    :label="item.label"
                    :value="item.value">
              <p style="float: left;width:80px">{{ item.partnerCode}}</p>
              <p style="float: left;width:390px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis">{{ item.partnerName }}</p>
              <p style="float: left;width:80px">{{ item.partnerType?(item.partnerType == 1?'供应商':''):'客户' }}</p>
              <p style="float: left;width:110px">{{ item.cityName?item.cityName:'-' }}</p>
              <p style="float: left;width:100px">{{ item.phone?item.phone:'-' }}</p>
          </el-option>
        </el-select>
        <el-time-picker v-else-if="item.type == 'pickerTime'"
          v-model="searchInfo[item.value1]" size="small" :disabled="item.disabled" style="width:130px" :clearable="false" value-format="HH:mm:ss"
          placeholder="任意时间点">
        </el-time-picker>
        <div v-else-if="item.type == 'period'">
          <el-date-picker v-model="searchInfo[item.value1]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :clearable="false"
                          :disabled="item.disabled"
                          :picker-options="getPeriodStartOptions(item)">
          </el-date-picker>
          -
          <el-date-picker v-model="searchInfo[item.value2]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="结束时间"
                          :clearable="false"
                          :disabled="item.disabled"
                          :picker-options="getPeriodEndOptions(item)">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'period1'">
          <el-date-picker v-model="searchInfo[item.value3]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          :clearable="item.clearable?false:true"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="开始日期时间"
                          :picker-options="getPeriodStartOptions(item)"
                          @change="onPeriodChange(item, 'start')">
          </el-date-picker>
          -
          <el-date-picker v-model="searchInfo[item.value4]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="结束日期时间"
                          :picker-options="getPeriodEndOptions(item)"
                          @change="onPeriodChange(item, 'end')">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodYMDHMS'">
          <el-date-picker v-model="searchInfo[item.value]"
                          style="width:190px"
                          size="small"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="开始日期时间"
                          :picker-options="pickerOptions"
                          :clearable="false">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodMonth'">
          <el-date-picker v-model="searchInfo[item.value]"
                          style="width:130px"
                          size="small"
                          type="month"
                          value-format="yyyy-MM"
                          placeholder="选择年月"
                          :picker-options="starttime"
                          :clearable="false">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'month'">
          <el-date-picker v-model="searchInfo[item.value]"
                          style="width:130px"
                          size="small"
                          type="month"
                          value-format="MM"
                          placeholder="选择月"
                          :picker-options="starttime">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'year'">
          <el-date-picker v-model="searchInfo[item.value]"
                          style="width:130px"
                          size="small"
                          type="year"
                          value-format="yyyy"
                          placeholder="选择年">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodymd'">
          <el-date-picker v-model="searchInfo[item.value1]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :clearable="item.clearable === true">
          </el-date-picker>
        </div>
        <div v-else-if="item.type == 'periodymdTwo'">
          <el-date-picker v-model="searchInfo[item.value1]"
                          style="width:130px"
                          size="small"
                          :type="item.datetime"
                          value-format="yyyy-MM-dd"
                          placeholder="开始时间"
                          :picker-options="pickerOptionsMdTwo"
                          :clearable="false">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <span class="button button1"
              @click="handleClick('search')">
          <i class="el-icon-search">搜索</i>
        </span>
        <span class="button button2"
              @click="handleClick('refresh')">
          <i class="el-icon-refresh">重置</i>
        </span>
      </el-form-item>
    </el-form>
    <i v-if="filter.mone && filter.moneBut" class="el-icon-arrow-down" style="position: relative;top: 2px;font-size:16px;color:#2a7cc9" @click="filter.moneBut = !filter.moneBut"></i>
    <i v-if="filter.mone && !filter.moneBut" class="el-icon-arrow-up" style="position: relative;top: 2px;font-size:16px" @click="filter.moneBut = !filter.moneBut"></i>
  </div>
</template>
<script>
/** 筛选开始时间快捷项：自然日 0 点（daysAgo=0 今天，1 昨天） */
function pickDateAtDayStart (daysAgo) {
  const date = new Date()
  date.setDate(date.getDate() - daysAgo)
  date.setHours(0, 0, 0, 0)
  return date
}

export default {
  name: 'BoyoFilter',
  props: {
    filter: Object,
    //++----------------
    result: {
      type: Object,
      default: {}
    },
    listTypeInfo: Object
  },
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(0));
          }
        }, {
          text: '昨天',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(1));
          }
        }, {
          text: '一周前',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(7));
          }
        }, {
          text: '一月前',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(30));
          }
        }, {
          text: '三个月前',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(90));
          }
        }, {
          text: '半年前',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(180));
          }
        }, {
          text: '一年前',
          onClick(picker) {
            picker.$emit('pick', pickDateAtDayStart(365));
          }
        }]
      },
      endOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }]
      },
      pickerOptionsMdTwo:{
        disabledDate:(time)=>{
          return time.getTime()<Date.now()-1*24*60*60*1000
        }
      },
      starttime: {},
      value5: '',
      searchInfo: {},
      event: '' // 配合select的远程搜索事件
    }
  },
  watch: {
    'filter.visible' (val) {
      let screenWidth = document.body.clientWidth
      if (screenWidth <= 960) {
        this.$refs.Boyofilter.style.display =
          this.$refs.Boyofilter.style.cssText === 'display: block;'
            ? 'none'
            : 'block'
      } else {
        // this.$refs.Boyofilter.style.display = this.$refs.Boyofilter.style.cssText === 'display: none;' ? 'block' : 'none'
      }
    },
    //++----------------
    'searchInfo': {
      deep: true,
      handler (val, old) {
        Object.assign(this.result, val)
      }
    }
  },
  mounted () {
    this.initParams()
  },
  methods: {
    initParams () {
      this.searchInfo = Object.assign({}, this.filter.data || {})
      Object.assign(this.result, this.searchInfo)
    },
    handleClick (val) {
      this.$emit('handleClick', val, this.searchInfo)
    },
    remoteMethod (query) {
      // console.log(query)
      // if (query) {
        this.$emit('formremoteMethod', this.event, query, 'remoteMethod')
      // }
    },
    none () { },
    selectHeaderClick(label){
      this.$emit('selectHeaderClick', label)
    },
    selectChange (val) {
      this.$emit('formremoteMethod', this.event, val, 'select')
    },
    focus (val) {
      this.event = val
    },
    parseFilterDate (val) {
      if (!val) return null
      return new Date(String(val).replace(/-/g, '/'))
    },
    dayStartTime (val) {
      const date = this.parseFilterDate(val)
      if (!date) return null
      date.setHours(0, 0, 0, 0)
      return date.getTime()
    },
    getPeriodStartKey (item) {
      return item.type === 'period1' ? item.value3 : item.value1
    },
    getPeriodEndKey (item) {
      return item.type === 'period1' ? item.value4 : item.value2
    },
    getPeriodStartOptions (item) {
      const endVal = this.searchInfo[this.getPeriodEndKey(item)]
      const endDay = this.dayStartTime(endVal)
      return {
        shortcuts: this.pickerOptions.shortcuts,
        disabledDate: (time) => {
          if (endDay == null) return false
          return time.getTime() > endDay
        }
      }
    },
    getPeriodEndOptions (item) {
      const startVal = this.searchInfo[this.getPeriodStartKey(item)]
      const startDay = this.dayStartTime(startVal)
      return {
        shortcuts: this.endOptions.shortcuts,
        disabledDate: (time) => {
          if (startDay == null) return false
          return time.getTime() < startDay
        }
      }
    },
    onPeriodChange (item, role) {
      if (item.type !== 'period1') return
      const startKey = this.getPeriodStartKey(item)
      const endKey = this.getPeriodEndKey(item)
      const startVal = this.searchInfo[startKey]
      const endVal = this.searchInfo[endKey]
      if (!startVal || !endVal) return
      const start = this.parseFilterDate(startVal)
      const end = this.parseFilterDate(endVal)
      if (start.getTime() > end.getTime()) {
        this.$set(this.searchInfo, role === 'start' ? startKey : endKey, role === 'start' ? endVal : startVal)
      }
    }
  }
}
</script>
<style>
</style>
<style lang="stylus" scoped>
.selectPartner{
  // margin-top: 15px !important;
}
.heade2
  overflow hidden
.heade
  position fixed
  z-index 100
  width 100%
.test1
  display block
.test2
  display none
.button
  margin 0px
  padding 0px
  border 0px
  outline none
  padding 6px 10px
  border-radius 3px
  cursor pointer
.button1
  background #3c414b
  color #fff
// .button1:hover
//   background #19bdbd
// .button1:active
//   background #26a5a5
.button2
  background #ffffff
  color #333333
  border 1px solid #eeeeee
.button2:hover
  background #fbf7f7
.button2:active
  background #eceae7
</style>



// WEBPACK FOOTER //
// src/components/BoyoFilter/index.vue